// extracted by mini-css-extract-plugin
export default {"wrapper":"n490u","item":"V8LjO"};